<template>
  <div id="form" ref="form" class="overflow-y no--sb">
    <div id="overlay"></div>
    <!--  type 1  -->
    <div class="form-header" v-if="route.query.form === 'type1'">
      <button class="flex align-center justify-center pointer" @click="pushTo('Step11', route.query)"><i class="fas fa-chevron-left"></i><span>簡易お見積りへ戻る</span></button>
      <h2 class="title text-center">仮オーダーフォーム</h2>
      <h4 class="sub-title text-center">パートナー様が先に送信済みの方は<u class="pointer" @click="changeFormTypeTo('type2')">簡易オーダーフォーム</u>をご利用ください</h4>
    </div>
    <form-type1 v-if="route.query.form === 'type1'" />

    <!--  type 2  -->
    <div class="form-header" v-if="route.query.form === 'type2'">
      <button class="flex align-center justify-center pointer" @click="changeFormTypeTo('type1')"><i class="fas fa-chevron-left"></i><span>オーダーフォームへ</span></button>
      <h2 class="title text-center">簡易オーダーフォーム</h2>
    </div>
    <form-type2 v-if="route.query.form === 'type2'" />

    <!--  type 3  -->
    <div class="form-header form3" v-if="route.query.form === 'type3'">
      <button class="flex align-center justify-center pointer" @click="pushTo('Step11', route.query)"><i class="fas fa-chevron-left"></i><span>簡易お見積りへ戻る</span></button>
      <h2 class="title text-center">ご相談フォーム</h2>
    </div>
    <form-type3 v-if="route.query.form === 'type3'" />
  </div>
</template>

<script>
import {onMounted,computed, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import useRoutePush from "@/modules/moduleA/helpers/useRoutePush";
import FormType1 from "@/modules/moduleA/components/forms/types/FormType1";
import FormType2 from "@/modules/moduleA/components/forms/types/FormType2";
import FormType3 from "@/modules/moduleA/components/forms/types/FormType3";
export default {
  name: "Form",
  components: {FormType3, FormType2, FormType1},
  setup(){
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const form = ref(null)
    const {pushTo} = useRoutePush()

    // console.log(store.state.moduleA.results)
    // const results = computed(() => {
    //   return store.state.moduleA.results
    // })
    // console.log(results.value)


    onMounted(() => {
      form.value.addEventListener("scroll", scrollHandler)
    })

    function scrollHandler(e){
      const scrolled = e.target.scrollTop > 0
      store.commit("setScrolled", scrolled)
    }

    const changeFormTypeTo = (type) => {
      let queryObj = JSON.parse(JSON.stringify(route.query))
      queryObj.form = type
      router.replace({query:queryObj}).then(() => {})
    }
    return {route, pushTo, form, changeFormTypeTo}
  }
}
</script>

<style scoped>
#form {
  padding: 0 0 40px 0;
  max-width: 100% !important;
  height: 100% !important;
  background: rgb(244,244,244);
}
#form > .form-header {
  background: linear-gradient(0deg, rgba(244,244,244,1) 38%, rgba(244,244,244,1) 44%, rgba(255,255,255,1) 72%);
  padding: 0 0 80px 0;
}
#form > .form-header.form3 {
  padding: 0;
}
#form > .form-header > button {
  position: relative;
  margin: auto;
  height: 62px;
}
#form > .form-header > button > .fa-chevron-left {
  opacity: .1;
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 48%;
  transform: translate(-50%, -50%);
  font-size: 4rem;
}
#form > .form-header > button > span {
  position: relative;
  z-index: 2;
}
#form > .form-header h2.title {
  font-weight: 400;
  padding-top: 40px;
  margin-bottom: 40px;
  font-size: 1.6rem;
}
#form > .form-header h4.sub-title {
  font-weight: 400;
  font-size: 1rem;
}

#form > #overlay {
  display: none;
}
#form > #overlay.active {
  display: block;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.3);
}
</style>
